import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Diagnostic: log tab visibility changes (helps debug "Loading on tab return" issue)
document.addEventListener('visibilitychange', () => {
  if (typeof console !== 'undefined' && console.log) {
    console.log('[TabVisibility] document.visibilityState ->', document.visibilityState);
  }
});

reportWebVitals();
